import type { CSSProperties } from "react";

/** Shared Hub zone panel chrome (Today's Picks, Watchtower, Portfolios Select Portfolio). */
export const HUB_PANEL_SURFACE: CSSProperties = {
  borderRadius: 16,
  background: "rgba(255,255,255,0.035)",
  border: "1px solid rgba(255,255,255,0.07)",
};

export function hubPanelSurfaceShell(isMobile: boolean): CSSProperties {
  return {
    ...HUB_PANEL_SURFACE,
    overflow: "visible",
  };
}

/** Content insets inside a hub panel shell (matches `.hub-list-monitor-panel`). */
export function hubPanelSurfaceInsets(isMobile: boolean) {
  return isMobile
    ? { top: 16, right: 12, bottom: 20, left: 12, headerRight: 12 }
    : { top: 22, right: 16, bottom: 26, left: 16, headerRight: 16 };
}
